const getAllNextSiblings = (elem, targetClass) => {
  let siblings = [];
  while (elem.nextElementSibling && Array.from(elem.nextElementSibling.classList).includes(targetClass) && !Array.from(elem.nextElementSibling.classList).includes('js-hidden-input-group')) {
    elem = elem.nextElementSibling;
    siblings.push(elem);
  }
  return siblings;
}

const createContactPersons = () =>{
  const domFormFieldsWrappers = document.querySelectorAll('.js-hidden-input-group');

  domFormFieldsWrappers.forEach((domFormFieldsWrapper, index) =>{
    const domFormGroupsUntilNextWrap = getAllNextSiblings(domFormFieldsWrapper, 'form-group');

    if(domFormGroupsUntilNextWrap.length > 0){
      const domFormGroupsWrapper = document.createElement('div');
      domFormGroupsWrapper.className = `${Array.from(domFormGroupsUntilNextWrap[0].classList).join(' ')}`;
      domFormGroupsWrapper.id = `js-hidden-form-group-container-${index}`;
      const row = document.createElement('div');
      row.className = 'row';
      
      if(index > 0){
        domFormGroupsWrapper.classList.add('d-none');
      }
      const title = domFormFieldsWrapper.getAttribute('title');
      const separator = document.createElement('hr');

      domFormGroupsWrapper.append(separator);
      
      if(title){
        const titleElem = document.createElement('h4');
        titleElem.textContent = title;
        domFormGroupsWrapper.append(titleElem);
      }

      row.append(...domFormGroupsUntilNextWrap)
      
      domFormGroupsWrapper.append(row);
      
      const btnWrapper = document.createElement('div');
      btnWrapper.className = 'd-flex';
      
      if( (index + 1) < domFormFieldsWrappers.length){
        const domShowNextWrappingBtn = document.createElement('button');
        domShowNextWrappingBtn.type = 'button';
        domShowNextWrappingBtn.innerHTML = `<i class="material-icons">add</i> ${domFormFieldsWrapper.getAttribute('placeholder') ?? domFormFieldsWrapper.dataset.addText}`;
        domShowNextWrappingBtn.className = 'btn btn-dark btn-sm js-hidden-form-group-container-add-btn mr-1';
        domShowNextWrappingBtn.addEventListener('click', (event) =>{
          const addBtn = event.target;
          const oldTarget = document.getElementById(`js-hidden-form-group-container-${index}`);
          const newTarget = document.getElementById(`js-hidden-form-group-container-${index + 1}`);
          newTarget.classList.remove('d-none');
          addBtn.classList.add('d-none');
          const oldRemoveBtn = oldTarget.querySelector('.js-hidden-form-group-container-remove-btn');
          if(oldRemoveBtn !== null){
            oldRemoveBtn.classList.add('d-none');
          }
        });

        btnWrapper.append(domShowNextWrappingBtn)

      }
      
      if(index > 0 && (index + 1) <=  domFormFieldsWrappers.length){
        const domRemoveCurrentBtn = document.createElement('button');
        domRemoveCurrentBtn.type = 'button';
        domRemoveCurrentBtn.innerHTML = `<i class="material-icons">clear</i> ${domFormFieldsWrapper.dataset.removeText}`;
        domRemoveCurrentBtn.className = 'btn btn-dark btn-sm js-hidden-form-group-container-remove-btn';
        domRemoveCurrentBtn.addEventListener('click', (event) =>{
          const newTarget = document.getElementById(`js-hidden-form-group-container-${index}`);
          const oldTarget = document.getElementById(`js-hidden-form-group-container-${index - 1}`);
          newTarget.classList.add('d-none');
          newTarget.querySelectorAll('input').forEach(i => i.value = '');
          oldTarget.querySelector('.js-hidden-form-group-container-add-btn').classList.remove('d-none');

          const oldRemoveBtn = oldTarget.querySelector('.js-hidden-form-group-container-remove-btn');
          if(oldRemoveBtn !== null){
            oldRemoveBtn.classList.remove('d-none');
          }
        });
        btnWrapper.append(domRemoveCurrentBtn)
      }

      domFormGroupsWrapper.append(btnWrapper);
      
      

      domFormFieldsWrapper.after(domFormGroupsWrapper);
    }

  });
}



document.addEventListener('DOMContentLoaded', () =>{
  createContactPersons();
});